// extracted by mini-css-extract-plugin
module.exports = {"speciesName":"BreakdownGroup_speciesName__1NNHx","breakdownContainer":"BreakdownGroup_breakdownContainer__3c-ya"};